module.exports = __webpack_public_path__ + "static/tacoma3-7f275ada195f7fb74ee230ae404ddca2.png";